import { addSearchBoxInteractedTrackingEvent } from "@website/ticket-ui/common/helper/searchBoxInteractedTrackingEvents";
import { tripTypeMap } from "@website/website-ui/utils/tracking-properties-map";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useSaleType = (value: string) => {
  const [saleType, setSaleType] = useState<string>("one-way");
  const saleTypeList = useMemo(
    () => [
      { title: "یک طرفه", value: "one-way" },
      {
        title: "رفت و برگشت",
        value: "round-trip"
      }
    ],
    []
  );

  useEffect(() => {
    value && setSaleType(value);
  }, [value]);

  const onChangeSaleType = useCallback((value: string) => {
    setSaleType(value);
    const tripType = value === "single" ? "oneway" : "roundtrip";
    addSearchBoxInteractedTrackingEvent({
      trip_type: tripTypeMap[tripType]
    });
  }, []);

  const onChangeDatepickerMode = useCallback((value: string) => {
    if (value === "single") {
      setSaleType("one-way");
    } else if (value === "same-start-end") {
      setSaleType("round-trip");
    }
  }, []);

  return { saleType, saleTypeList, onChangeSaleType, onChangeDatepickerMode };
};
